module.exports = __webpack_public_path__ + "images/places/export_6821-a7048a6cdfca7f8f1473b4b8d8140380.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/export_6821.jpg
 ** module id = 291
 ** module chunks = 0
 **/